import React, { useRef } from 'react';
import { Box } from '@mui/material';

const LENGTH = 4;

/** Four single-digit boxes, same pattern as the WappGrow sign-in. */
export default function OtpInput({ value, onChange, disabled }) {
  const refs = useRef([]);
  const digits = Array.from({ length: LENGTH }, (_, i) => value[i] || '');

  const set = (index, digit) => {
    const next = [...digits];
    next[index] = digit;
    onChange(next.join(''));
  };

  return (
    <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'center', my: 2 }}>
      {digits.map((d, i) => (
        <Box
          key={i}
          component="input"
          ref={(el) => { refs.current[i] = el; }}
          value={d}
          disabled={disabled}
          inputMode="numeric"
          maxLength={1}
          aria-label={`Digit ${i + 1}`}
          onChange={(e) => {
            const digit = e.target.value.replace(/\D/g, '').slice(-1);
            set(i, digit);
            if (digit && refs.current[i + 1]) refs.current[i + 1].focus();
          }}
          onKeyDown={(e) => {
            if (e.key === 'Backspace' && !digits[i] && refs.current[i - 1]) refs.current[i - 1].focus();
          }}
          onPaste={(e) => {
            const text = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, LENGTH);
            if (text) { e.preventDefault(); onChange(text); }
          }}
          sx={{
            width: 52,
            height: 56,
            textAlign: 'center',
            fontSize: 24,
            fontWeight: 600,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
            outline: 'none',
            '&:focus': { borderColor: 'primary.main', boxShadow: '0 0 0 3px rgba(25,118,210,0.15)' },
          }}
        />
      ))}
    </Box>
  );
}
